// extracted by mini-css-extract-plugin
module.exports = {"Button":"styles_Button__46YdH","smallArrow":"styles_smallArrow__F2iYX","arrowUp":"styles_arrowUp__unjbA","arrowDown":"styles_arrowDown__b0F1W"};